<template>
	<div class="line">
		<div class="line-left">
			<div class="bg1"></div>
		</div>
		<div ref="linechart" class="linechart"></div>
	</div>
</template>

<script>
import * as methods from './method.js'
export default {
	name: 'template.scope65',
	props: {
		vdata: {
			type: [Array, String],
			default: () => []
		},
		jsondata: {
			type: [Array, String],
			default: () => []
		},
		scopedata: {
			type: Object,
			default: () => { }
		}
	},
	data() {
		return {
			title: '饼图-scope65',
			timer: null,
			defaultdata: [
				{ value1: '成果1', value2: '25' },
				{ value1: '成果2', value2: '15' },
				{ value1: '成果3', value2: '25' },
				{ value1: '成果4', value2: '15' },
				{ value1: '成果5', value2: '30' },
			],
			valueMap: [
				{ name: '名称', key: "value1" },
				{ name: '数值', key: "value2" },
			],
			exceldata: [],
			apiconfig: {},
			isApi: false,
			scope: {},
			config: {
			},
		}
	},
	watch: {
		vdata(n) {
			if (n && n.length) {
				let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
			}
		},
		jsondata(n) {
			this.exceldata = n
		},
		defaultdata(n) {
			this.DrawEcharts()
		}
	},
	beforeDestroy() {
		clearInterval(this.timer);
		this.timer = null
	},
	methods: {
		...methods,
		DrawEcharts() {
			clearInterval(this.timer);
			this.timer = null
			var echarts = require('echarts');
			var TmyChart = echarts.init(this.$refs.linechart);
			let colorData = [
				'#e09b2c',
				'#004cc8',
				'#f26361',
				'#00ffbf',
				'#00d9ff'
			];
			let mydata = this.defaultdata.map((item, i) => {
				let newitem = {
					name: item.value1,
					value: item.value2,
					itemStyle: { color: colorData[i] }
				}
				return newitem
			})
			var Toption = {
				tooltip: {
					trigger: 'item'
				},
				series: [
					{
						type: 'pie',
						//选中ple的中间40-50
						center: ['50%', '50%'],
						radius: ['55%', '65%'],
						label: {
							color: '#C6D2D8',
							fontSize: 12,
							alignTo: 'labelLine',
							align: 'left',
							formatter: function (params) {
								// console.log(params, "|l3|");
								let newFor = `${params.data.name}\n${params.percent}%`;
								return newFor
							},
						},
						labelLine: {
							lineStyle: {
								color: '#748496',
							},
						},
						// labelLayout: function (params) {
						// 	const isLeft = params.labelRect.x < myChart.getWidth() / 2;
						// 	const points = params.labelLinePoints;
						// 	// Update the end point.
						// 	points[2][0] = isLeft
						// 		? params.labelRect.x
						// 		: params.labelRect.x + params.labelRect.width;
						// 	return {
						// 		labelLinePoints: points
						// 	};
						// },
						data: mydata

					}
				]
			};
			Toption && TmyChart.setOption(Toption);
			this.timer = setInterval(function () {
				TmyChart.clear();
				Toption && TmyChart.setOption(Toption);
			}, 5000)
		},
	},
	created() {

	},
	mounted() {
		if (this.vdata && this.vdata.length) {
			this.defaultdata = this.vdata
		}
		if (this.jsondata && this.jsondata.length) {
			this.exceldata = this.jsondata
		}
		this.setData()
		this.DrawEcharts(); //需要刷新的数据
	},
}
</script>

<style scoped>
.line {
	width: 435px;
	height: 240px;
	display: flex;
	position: relative;
	overflow: hidden;
	padding: 10px 0;
}

.line-left {
	width: 100%;
	height: 100%;
}

.line-left .bg1 {
	width: 180px;
	height: 180px;
	margin: 48px auto 0px;
	box-sizing: border-box;
	background: url('@/assets/pie-bg5.png') no-repeat;
	background-size: 100%;
	/* position: relative; */
	/* z-index: 1; */
}



.linechart {
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0px;
	z-index: 5;
}
</style>